export default {
  welcome: 'Hello, {{name}}',
  needHelp: 'Need help?'
}
